<template>
  <v-card :outlined="outlined"
          :class="`mb-3 rounded-card ${outlined ? '': 'card-shadow'}`">
    <v-card-text class="text--primary">
      <v-list-item dense>
        <v-row dense>
          <v-col cols="12" sm="2">
            <px-nota-fiscal-chave-acesso :nota-fiscal="notaFiscal"/>
            <div class="caption">
              <px-span-tooltip top :text="numeroSerie" tooltip="Número / Série"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            {{ notaFiscal.comprador.pessoa.nome | truncate(30) }}
            <div class="caption">
              {{ notaFiscal.comprador.pessoa.cnpj | cnpj }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <px-nota-fiscal-fornecedor :nota-fiscal="notaFiscal"/>
          </v-col>
          <v-col cols="12" sm="2" class="text-center">
            {{ notaFiscal.dataEmissao | date }}
            <div class="caption">
              Data emissão
            </div>
          </v-col>
          <v-col cols="12" class="font-weight-bold text-center" sm="2">
            {{ notaFiscal.totalNotaFiscal | currency }}
            <div class="caption">
              Valor total
            </div>
          </v-col>
        </v-row>
        <v-list-item-action>
          <px-nota-fiscal-detalhe-dialog :nota-fiscal="notaFiscal"/>
        </v-list-item-action>
        <v-list-item-action>
          <v-btn icon @click="onClickExpand">
            <v-icon>
              {{ expandIcon }}
            </v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <transition name="scroll-y-transition">
        <div class="mt-3" v-if="expanded">
          <px-nota-fiscal-item-details :nota-fiscal-prop="notaFiscal"/>
        </div>
      </transition>
    </v-card-text>
  </v-card>
</template>

<script>
import NotaFiscalChaveAcesso from '@/modules/notas-fiscais/NotaFiscalChaveAcesso.vue';
import NotaFiscalFornecedor from '@/modules/notas-fiscais/NotaFiscalFornecedor.vue';
import NotaFiscalItemDetails from '@/modules/notas-fiscais/NotaFiscalItemDetails.vue';
import NotaFiscalDetalheDialog from '@/modules/notas-fiscais/detalhes/NotaFiscalDetalheDialog.vue';

export default {
  props: {
    outlined: {
      type: Boolean,
      default: true,
    },
    notaFiscal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    numeroSerie() {
      return `${this.notaFiscal.numero} / ${this.notaFiscal.serie}`;
    },
    expandIcon() {
      return this.expanded ? 'mdi-chevron-up' : 'mdi-chevron-down';
    },
  },
  methods: {
    onClickExpand() {
      this.expanded = !this.expanded;
    },
  },
  components: {
    pxNotaFiscalChaveAcesso: NotaFiscalChaveAcesso,
    pxNotaFiscalFornecedor: NotaFiscalFornecedor,
    pxNotaFiscalItemDetails: NotaFiscalItemDetails,
    pxNotaFiscalDetalheDialog: NotaFiscalDetalheDialog,
  },
};
</script>
